import type { Thunk } from 'types/redux'
import api from '@disco/api/server'
import {
  CAMPAIGN_FOOTER_CREATE,
  CAMPAIGN_FOOTER_CREATE_FAIL,
  CAMPAIGN_FOOTER_CREATE_SUCCESS,
  CAMPAIGN_FOOTER_DELETE,
  CAMPAIGN_FOOTER_DELETE_FAIL,
  CAMPAIGN_FOOTER_DELETE_SUCCESS,
  CAMPAIGN_FOOTER_UPDATE,
  CAMPAIGN_FOOTER_UPDATE_FAIL,
  CAMPAIGN_FOOTER_UPDATE_SUCCESS,
  CAMPAIGN_FOOTERS_LOAD,
  CAMPAIGN_FOOTERS_LOAD_FAIL,
  CAMPAIGN_FOOTERS_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
/**
 * Loads all campaign footers from the server.
 * @returns Thunk that fetches campaign footers
 */
export const loadCampaignFooters = (): Thunk => async dispatch => {
  dispatch({
    type: CAMPAIGN_FOOTERS_LOAD,
  })

  try {
    const response = await api.getCampaignFooters()
    return dispatch({
      type: CAMPAIGN_FOOTERS_LOAD_SUCCESS,
      result: response.results,
    })
  } catch (error) {
    return dispatch({
      type: CAMPAIGN_FOOTERS_LOAD_FAIL,
      error,
    })
  }
}
/**
 * Deletes a campaign footer by ID.
 * @param id - ID of the footer to delete
 * @returns Thunk that deletes the campaign footer
 */
export const deleteCampaignFooter =
  (id: number): Thunk =>
  async dispatch => {
    try {
      dispatch({
        type: CAMPAIGN_FOOTER_DELETE,
        id,
      })
      await api.deleteCampaignFooter(id)
      return dispatch({
        type: CAMPAIGN_FOOTER_DELETE_SUCCESS,
        id,
      })
    } catch (error) {
      return dispatch({
        type: CAMPAIGN_FOOTER_DELETE_FAIL,
        id,
        error,
      })
    }
  }
/**
 * Updates an existing campaign footer.
 * @param id - ID of the footer to update
 * @param footer - Footer data to update
 * @returns Thunk that updates the campaign footer
 */
export const updateCampaignFooter =
  (id: number, footer: Record<string, any>): Thunk =>
  async dispatch => {
    try {
      dispatch({
        type: CAMPAIGN_FOOTER_UPDATE,
      })
      const result = await api.updateCampaignFooter(id, footer)
      dispatch({
        type: CAMPAIGN_FOOTER_UPDATE_SUCCESS,
        id,
        result,
      })
      return result
    } catch (error) {
      dispatch({
        type: CAMPAIGN_FOOTER_UPDATE_FAIL,
        error,
      })
      throw error
    }
  }
/**
 * Creates a new campaign footer.
 * @param footer - Footer data for the new footer
 * @returns Thunk that creates a campaign footer
 */
export const createCampaignFooter =
  (footer: Record<string, any>): Thunk =>
  async dispatch => {
    try {
      dispatch({
        type: CAMPAIGN_FOOTER_CREATE,
      })
      const result = await api.createCampaignFooter(footer)
      dispatch({
        type: CAMPAIGN_FOOTER_CREATE_SUCCESS,
        result,
      })
      return result
    } catch (error) {
      dispatch({
        type: CAMPAIGN_FOOTER_CREATE_FAIL,
        error,
      })
      throw error
    }
  }
